import cryptoJs from 'crypto-js';

export const sha256Encrypt = (text: string): string => {
	const hash: cryptoJs.lib.WordArray = cryptoJs.SHA256(text);

	return hash.toString(cryptoJs.enc.Hex);
};
